import React, { useState } from 'react';
import clsx from 'clsx';
import { Select, MenuItem, FormControl } from '@material-ui/core';
import { useStyles } from './styles';
import { ReactComponent as ChevronDownSVG } from './assets/chevron-down.svg';

export const SelectInput = (props: any) => {
  const { value, onChange, options } = props;
  const [open, setOpen] = useState(false);
  const classes = useStyles({ open, value });

  return (
    <FormControl fullWidth>
      <Select
        labelId="filter-select-label"
        id="filter-select"
        value={value}
        onChange={onChange}
        className={clsx(classes.filterSelect, classes.bgColor)}
        disableUnderline
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        IconComponent={() => <ChevronDownSVG />}
        displayEmpty
      >
        {options.length > 0 &&
          options.map((option: any) => {
            return (
              <MenuItem key={option.name} value={option.value}>
                {option.name}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
  );
};

export default SelectInput;
